exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2YqHaNr7AxdT45Zi8VE4lo,._7WS-6bgq7Wp3KBLcn-lEO{width:32px;height:32px;display:inline-block}html[dir] ._2YqHaNr7AxdT45Zi8VE4lo,html[dir] ._7WS-6bgq7Wp3KBLcn-lEO{background-color:transparent}._2YqHaNr7AxdT45Zi8VE4lo{width:16px;height:16px}html[dir] .JfNle5WjFhEs0bokdMeaU{margin:10px 10px 10px 10px}", ""]);
// Exports
exports.locals = {
	"extraSmallIcon": "_2YqHaNr7AxdT45Zi8VE4lo",
	"icon": "_7WS-6bgq7Wp3KBLcn-lEO",
	"iconDefault": "JfNle5WjFhEs0bokdMeaU"
};